import { render, staticRenderFns } from "./NewInventory.vue?vue&type=template&id=74d0d274&scoped=true&"
import script from "./NewInventory.vue?vue&type=script&lang=js&"
export * from "./NewInventory.vue?vue&type=script&lang=js&"
import style0 from "./NewInventory.vue?vue&type=style&index=0&id=74d0d274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d0d274",
  null
  
)

export default component.exports